/**
 *  TopbarMobileMenu prints the menu content for authenticated user or
 * shows login actions for those who are not authenticated.
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// import logo from '../../../../assets/logo_header.png';
import logo from '../../../../assets/NewLogos/LOGO-orangebg.svg'
import { ACCOUNT_SETTINGS_PAGES } from '../../../../routing/routeConfiguration';
import { FormattedMessage } from '../../../../util/reactIntl';
import { propTypes } from '../../../../util/types';
import { ensureCurrentUser } from '../../../../util/data';

import {
  AvatarLarge,
  ExternalLink,
  InlineTextButton,
  NamedLink,
  NotificationBadge,
  Button,
} from '../../../../components';

import css from './TopbarMobileMenu.module.css';

const CustomLinkComponent = ({ linkConfig, currentPage }) => {
  const { group, text, type, href, route } = linkConfig;
  const getCurrentPageClass = page => {
    const hasPageName = name => currentPage?.indexOf(name) === 0;
    const isCMSPage = pageId => hasPageName('CMSPage') && currentPage === `${page}:${pageId}`;
    const isInboxPage = tab => hasPageName('InboxPage') && currentPage === `${page}:${tab}`;
    const isCurrentPage = currentPage === page;

    return isCMSPage(route?.params?.pageId) || isInboxPage(route?.params?.tab) || isCurrentPage
      ? css.currentPage
      : null;
  };

  // Note: if the config contains 'route' keyword,
  // then in-app linking config has been resolved already.
  if (type === 'internal' && route) {
    // Internal link
    const { name, params, to } = route || {};
    const className = classNames(css.navigationLink, getCurrentPageClass(name));
    return (
      <NamedLink name={name} params={params} to={to} className={className}>
        <span className={css.menuItemBorder} />
        {text}
      </NamedLink>
    );
  }
  return (
    <ExternalLink href={href} className={css.navigationLink}>
      <span className={css.menuItemBorder} />
      {text}
    </ExternalLink>
  );
};

const TopbarMobileMenu = props => {
  const {
    isAuthenticated,
    currentPage,
    currentUserHasListings,
    currentUser,
    notificationCount,
    customLinks,
    onLogout,
  } = props;

  const user = ensureCurrentUser(currentUser);

  const extraLinks = customLinks.map(linkConfig => {
    return (
      <CustomLinkComponent
        key={linkConfig.text}
        linkConfig={linkConfig}
        currentPage={currentPage}
      />
    );
  });

  if (!isAuthenticated) {
    const signup = (
      <NamedLink name="SignupPage" className={css.signupLink}>
        <FormattedMessage id="TopbarMobileMenu.signupLink" />
      </NamedLink>
    );

    const login = (
      <NamedLink name="LoginPage" className={css.loginLink}>
        <FormattedMessage id="TopbarMobileMenu.loginLink" />
      </NamedLink>
    );

    const signupOrLogin = (
      <span className={css.authenticationLinks}>
        <FormattedMessage id="TopbarMobileMenu.signupOrLogin" values={{ signup, login }} />
      </span>
    );
    const shop = (
      <NamedLink name="ShopUsPage" className={classNames(css.navigationLink)}>
        <span>
          <FormattedMessage id="TopbarDesktop.shopLink" />
        </span>
      </NamedLink>
    );
    const home = (
      <NamedLink name="LandingPage" className={classNames(css.navigationLink)}>
        <span>
          <FormattedMessage id="Topbar.HomeLink" />
        </span>
      </NamedLink>
    );
    const sell = (
      <NamedLink
        name="SelectCategoryPage"
        className={classNames(css.navigationLink)}
        // className={false ? css.inboxLinklandingPage : css.inboxLink}
      >
        <span className={css.topbarLinkLabel}>
          <FormattedMessage id="TopbarDesktop.sellLink" />
        </span>
      </NamedLink>
    );
    const faq = (
      <NamedLink
        name="FaqPage"
        className={classNames(css.navigationLink)}
        // className={false ? css.inboxLinklandingPage : css.inboxLink}
      >
        <span className={css.topbarLinkLabel}>
          <FormattedMessage id="TopbarDesktop.FaqLink" />
        </span>
      </NamedLink>
    );
    const aboutUs = (
      <NamedLink
        name="AboutUsPage"
        className={classNames(css.navigationLink)}
        // className={false ? css.inboxLinklandingPage : css.inboxLink}
      >
        <span className={css.topbarLinkLabel}>
          <FormattedMessage id="TopbarDesktop.AboutLink" />
        </span>
      </NamedLink>
    );
    // const logo = (
    //   <NamedLink name="LandingPage" className={css.topbarLink}>
    //     <img className={css.logoLink} src={logo} alt="logo" />
    //   </NamedLink>
    // );
    // return (
    //   <div className={css.root}>
    //     <div className={css.content}>
    //       <NamedLink name="LandingPage" className={css.topbarLink}>
    //         <img className={css.logoLink} src={logo} alt="logo" />
    //       </NamedLink>
       
          
    //       <div className={css.spacer} />
    //     </div>
    //     <div className={css.footer}>
    //       <NamedLink name="LoginPage" className={css.buttonLink}>
    //         <Button className={css.button}>
    //           <FormattedMessage id="TopbarMobileMenu.loginLink" />
    //         </Button>
    //       </NamedLink>
    //     </div>
    //   </div>
    // );
  }

  const notificationCountBadge =
    notificationCount > 0 ? (
      <NotificationBadge className={css.notificationBadge} count={notificationCount} />
    ) : null;

  const displayName = user.attributes.profile.firstName;
  const currentPageClass = page => {
    const isAccountSettingsPage =
      page === 'AccountSettingsPage' && ACCOUNT_SETTINGS_PAGES.includes(currentPage);
    const isInboxPage = currentPage?.indexOf('InboxPage') === 0 && page?.indexOf('InboxPage') === 0;
    return currentPage === page || isAccountSettingsPage || isInboxPage ? css.currentPage : null;
  };
  const inboxTab = currentUserHasListings ? 'sales' : 'orders';

  return (
    <div className={css.root}>
      {/* <AvatarLarge className={css.avatar} user={currentUser} /> */}
      <div className={css.content}>
        {/* <span className={css.greeting}>
          <FormattedMessage id="TopbarMobileMenu.greeting" values={{ displayName }} />
        </span> */}
        <NamedLink name="LandingPage" className={css.topbarLink}>
          <img className={css.logoLink} src={logo} alt="logo" />
        </NamedLink>
        {/* <InlineTextButton rootClassName={css.logoutButton} onClick={onLogout}>
          <FormattedMessage id="TopbarMobileMenu.logoutLink" />
        </InlineTextButton> */}

        <div className={css.accountLinksWrapper}>
          {/* Home */}
          <NamedLink
            className={classNames(css.navigationLink, currentPageClass('LandingPage'))}
            name="LandingPage"
          >
            <FormattedMessage id="Topbar.HomeLink" />
          </NamedLink>

          {/* FAQs */}
          <NamedLink
            className={classNames(css.navigationLink, currentPageClass('FaqPage'))}
            name="FaqPage"
          >
            <FormattedMessage id="TopbarDesktop.FaqLink" />
          </NamedLink>

          {/* Dashboard */}
          <NamedLink
            className={classNames(css.navigationLink, currentPageClass(`InboxPage:${inboxTab}`))}
            name="InboxPage"
            params={{ tab: inboxTab }}
          >
            <FormattedMessage id="TopbarMobileMenu.inboxLink" />
            {notificationCountBadge}
          </NamedLink>

          {/* Profile Settings */}
          <NamedLink
            className={classNames(css.navigationLink, currentPageClass('ProfileSettingsPage'))}
            name="ProfileSettingsPage"
          >
            <FormattedMessage id="TopbarMobileMenu.profileSettingsLink" />
          </NamedLink>

          {/* About Us */}
          <NamedLink
            className={classNames(css.navigationLink, currentPageClass('AboutUsPage'))}
            name="AboutUsPage"
          >
            <FormattedMessage id="TopbarDesktop.AboutLink" />
          </NamedLink>

          {/* Contact */}
          <ExternalLink
            href="mailto:info@likenewonly.com"
            className={css.navigationLink}
          >
            <FormattedMessage id="TopbarMobileMenu.contactLink" />
          </ExternalLink>
        </div>
        {/* <div className={css.customLinksWrapper}>{extraLinks}</div> */}
        <div className={css.spacer} />
      </div>
      <div className={css.footer}>
      {isAuthenticated ? 
        <Button className={css.button} onClick={onLogout}>
          <FormattedMessage id="TopbarMobileMenu.logoutLink" />
        </Button>:  <NamedLink name="LoginPage" className={css.buttonLink}>
            <Button className={css.button}>
              <FormattedMessage id="TopbarMobileMenu.loginLink" />
            </Button>
          </NamedLink>}
      </div>
    </div>
  );
};

TopbarMobileMenu.defaultProps = { currentUser: null, notificationCount: 0, currentPage: null };

const { bool, func, number, string } = PropTypes;

TopbarMobileMenu.propTypes = {
  isAuthenticated: bool.isRequired,
  currentUserHasListings: bool.isRequired,
  currentUser: propTypes.currentUser,
  currentPage: string,
  notificationCount: number,
  onLogout: func.isRequired,
};

export default TopbarMobileMenu;
